import { useState, useEffect } from 'react';

const useFormValidation = (stateInicial, validate, fn, fnsucces = function () { }) => {

    const [fields, setFields] = useState(stateInicial);
    const [errors, setErrors] = useState({});
    const [submitForm, setSubmitForm] = useState(false);
    const [readyToSubmit, setReadyToSubmit] = useState(false);
    
    useEffect(() => {
        //if (!isUpdate) {
            checkIfReady();
        //}
        if (submitForm) {
            const noErrors = Object.keys(errors).length === 0;

            if (noErrors) {
                fn(fields); // Fn = function that ejecutes in the component
                fnsucces();
            } else {
                console.log("ERRORS")
            }
            setSubmitForm(false);
        }

    }, [errors, fields]);

    // when the user makes a change 
    const handleChange = (e) => {
       
        setFields({
            ...fields,
            [e.target.name]: e.target.value
        })

        delete errors[e.target.name]
        setErrors({
            ...errors,
        })
        checkIfReady();
    }

    // when the user submits the form
    const handleSubmit = (e) => {
        e.preventDefault();
        const { validationErrors } = validate(null, null, fields);
        setErrors(validationErrors);
        setSubmitForm(true);
    }

    // when onBlur is done
    const handleBlur = e => {
        const { validationErrors } = validate(e.target.name, e.target.value, null);
        setErrors({
            ...errors,
            ...validationErrors
        });
    }

    const handleAutoCompleteBlur = (valor, name) => {
        const { validationErrors } = validate(name, valor, null);
        setFields({
            ...fields,
            [name]: valor
        },()=>{
            setErrors({
                ...errors,
                ...validationErrors
            });
        })
    }

    // clear fields
    const clearFields = () => {
        setFields({

        })
    }
    //clear Errors
    const clearErrors = () => {
        setErrors({

        })
    }

    //check if ready to submit
    const checkIfReady = () => {
        if(Object.entries(fields).length > 0){
            const { numberOfErrors } = validate(null, null, fields);
            if (numberOfErrors === 0) {
                setReadyToSubmit(true);
            } else {
                setReadyToSubmit(false);
            }
        }
        
    }

    const handleChangeSelect = (newValue, idName) => {

        setFields({
            ...fields,
            [idName]: newValue[idName]
        })

        delete errors[idName]
        setErrors({
            ...errors,
        })

        checkIfReady();
    }


    // when onBlur is done
    const handleBlurSelect = (newValue, idName) => {
        const { validationErrors } = validate(idName, newValue, null);
        setErrors({
            ...errors,
            ...validationErrors
        });
    }

    // handle Change in case of Date
    const handleChangeDate = (newDate, idName) => {

        setFields({
            ...fields,
            [idName]: newDate
        })

        delete errors[idName]
        setErrors({
            ...errors,
        })
        checkIfReady();
    }

    const handleChangeNumber = (e) => {
        setFields({
            ...fields,
            [e.target.name]: Number(e.target.value)
        })

        delete errors[e.target.name]
        setErrors({
            ...errors,
        })
        checkIfReady();
    }


    return {
        fields,
        errors,
        readyToSubmit,

        handleSubmit,
        handleChange,
        handleChangeSelect,
        handleBlur,
        handleAutoCompleteBlur,

        handleBlurSelect,
        handleChangeDate,

        handleChangeNumber,
        clearFields,
        setFields,
        clearErrors,

    }
}

export default useFormValidation;